import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import action from './action'
Vue.use(Vuex)

const state = {
  metaInfo: {
    title: '',
    keywords: '',
    icon: '/static/images/unesco_mjk.jpg',
    url: '',
    description: ''
  },
  mobaoCategory: [], // 墨寶類別list
  mobaoCategoryLoading: false, // 墨寶類別loading
  mobaoList: [], // 墨寶list
  mobaoListLoading: false, // 墨寶listloading
  wallcardCategory: [], // 卡片類別list
  wallcardCategoryLoading: false, // 卡片類別loading
  wallcardList: [], // 卡片list
  wallcardListLoading: false, // 卡片listloading
  preMobaoArray: [], // 墨宝预览
  channelinfo: {}, // 直播信息
  playerConfig: {}, // 直播播放器配置
  liveContent: {}, // 直播信息文字
  bestServerInfo: {}, // 直播最佳服务器
  flushtime: 1000, // 下一次刷新时间
  zhiboReady: false, // 直播数据请求完备
  newMessageLoading: true, // 最新资讯是否加载完毕
  newMessageList: [], // 最新资讯列表
  baoenQueryList: [], // 报恩讲堂查询列表
  baoenQueryListSize: 0, // 报恩讲堂查询列表
  topspeech: {}, // 最新资讯列表
  topspeechShow: true, // 最新资讯列表是否显示，否则显示点击树后查询到的
  baoenTree: { code: 1, category: {AMTB_NAME: '最近更新'} }, // 报恩讲堂目录树
  baoenCategoryList: {}, // 點擊樹後查詢的列表
  playlistindex: 0, // 播放的集数
  indexFirstList: [], // 首页最新讲演
  indexFirstLoading: true,  // 最新讲演是否加载完毕
  dianboLoading: true,  // 最新讲演是否加载完毕
  dianboplayerConfig: {},  // 最新讲演是否加载完毕
  dianbodoc: {},  // 点播doc
  subtable: {}, // 点播信息
  specialtopicList: {}, // 点播信息
  countryCode: '0',  // 国家代码
  queryloading: false,  // 查询loading
  dianbobestserverinfo: {},  // 点播doc
  docAllHits: 0,  // 點播播放量
  mp4list: [],  // 点播doc
  mp3list: [],  // 点播doc
  mp4total: 0,  // 总集数
  mp3total: 0,  // 总集数
  aid: 0,  // 一天有效id
  hid: 0,  // 长时间有效用户id
  preUrl: '',  // 长时间有效用户id
  recentspeech: [],  // 长时间有效用户id
  hotspeech: [],  // 长时间有效用户id
  zhibocountry: 'cn', // 直播的地区代码
  dianbocountry: 'cn', // 点播的地区代码
  jiangtangInfo: {},  // 点播的总信息
  indexbottom: [],  // 首页底部的图片
  baoenloading: true,  // 首页底部的图片
  indexbottomLoading: true,  // 首页底部的图片加载
  fsInfoLoading: false,
  rsfsTypeList: [],
  rsfsList: [],
  rsfsTypes: [],
  rsfsObject: { menuName: '', nemuContent: '', id: 0, type: 1 },
  enlightTypes: [],
  enlightPage: { begin: 0, countItem: 0, nextPage: 0, pageCount: 0, pageNo: 1, pageSize: 10, rows: [] },
  enlightObject: { menuName: '', nemuContent: '', id: 0, type: 1 },
  enlightLoading: true, // 菁華開示總loading
  enlightInfoLoading: false, // 菁華詳細
  ebookTreeLoading: true,
  ebookTypes: [],
  ebookTops: [],
  ebookPage: { begin: 0, countItem: 0, nextPage: 0, pageCount: 0, pageNo: 1, pageSize: 10, rows: [] },
  cardTypes: [],
  cardPage: { begin: 0, countItem: 0, nextPage: 0, pageCount: 0, pageNo: 1, pageSize: 10, rows: [] },
  mediaData: {}, // videojs所需要的数据
  ftpstatement: ''// ftp声明
}

export default new Vuex.Store({
  state,
  action,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js